module.exports = __webpack_public_path__ + "static/media/Institution.97f355bb.svg";